export default __webpack_public_path__ + "static/media/RecordThumb.c9142f65.png";